/* eslint-disable no-console */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable import/no-cycle */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-array-index-key */
/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { Button, Card, Heading, Illustration, MAGNETIC_TOKENS, Spinner, Tooltip, css, utils } from '@appd/uik';
import { useEffect, useReducer, useState } from 'react';
import { DateTime } from 'luxon';
import { Spacer } from '../Spacer';
import { fetchItems } from './fetchItems/fetchItems';

export const Carousel = ({ fadeMs = 750, lingerMs = 3000 }) => {
  const [intervalBuster, setIntervalBuster] = useReducer((i: number) => i + 1, 0);

  const [isHovered, setIsHovered] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  const [items, setItems] = useState<typeof Carousel.SAMPLE_DATA>([]);

  const [selected, setSelected] = useState(0);

  useEffect(() => {
    if (isHovered || isLoading) {
      return;
    }

    const interval = setInterval(() => setSelected(s => (s + 1) % items.length), lingerMs);

    return () => clearInterval(interval);
  }, [intervalBuster, isHovered, items, lingerMs, isLoading]);

  utils.useEffect.unstrict(() => {
    const { lastUpdated = -Infinity, items = [] } = JSON.parse(Carousel.CACHE.get() ?? '{}') as {
      lastUpdated?: number;
      items?: typeof Carousel.SAMPLE_DATA;
    };

    if (Date.now() - lastUpdated < Carousel.CACHE.MS) {
      setItems(items);

      setIsLoading(false);

      return;
    }

    const nextUpdated = +DateTime.now();

    const controller = new AbortController();

    fetchItems(controller)
      .then(items => {
        setItems(items);

        if (items.length) {
          Carousel.CACHE.set(
            JSON.stringify({
              lastUpdated: nextUpdated,
              items,
            }),
          );
        }
      }, console.warn)
      .finally(() => setIsLoading(false));

    return () => controller.abort();
  }, []);

  return (
    <>
      <Spacer height={20} />

      <Heading
        className={{
          marginLeft: MAGNETIC_TOKENS.SPACING[1],
          color: '#373C42',
          fontFamily: 'Paris2024-Variable',
          // Too thick in Chrome
          fontWeight: 450 ?? 550,
          fontSize: 20,
          lineHeight: '34px',
        }}
      >
        Latest News
      </Heading>

      <Spacer height={9} />

      <div>
        <div
          className={css({
            position: 'relative',
            height: 319,
            boxSizing: 'border-box',
          })}
        >
          {isLoading && (
            <Spinner
              size="XLARGE"
              className={{ position: 'absolute', left: '50%', top: '50%', translate: '-50% -50%' }}
            />
          )}
          {!isLoading && items.length === 0 && (
            <Illustration secondary="Couldn't connect to news" icon="Health.InfoMessage" />
          )}
          {!isLoading &&
            items.map(({ title, description, link, image }, i) => (
              <Card
                key={i}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                containOverlays={false}
                hideHorizontal
                className={{
                  ...(i !== selected && { opacity: 0, pointerEvents: 'none' }),
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  height: '100%',
                  width: '100%',
                  boxSizing: 'border-box',
                  overflow: 'clip',
                  borderRadius: MAGNETIC_TOKENS.SPACING[3],
                  gap: 0,
                  padding: 0,
                  transition: `opacity ${fadeMs}ms`,
                }}
              >
                <img
                  className={css({
                    borderBottom: `2px solid ${MAGNETIC_TOKENS.COLORS.CONTROL_BORDER_WEAK}`,
                    objectFit: 'cover',
                    marginInline: -40,
                    objectPosition: '0 -50px',
                    height: 176,
                    boxSizing: 'border-box',
                  })}
                  src={image}
                />

                <div
                  className={css({
                    display: 'flex',
                    flexDirection: 'column',
                    boxSizing: 'border-box',
                    height: 139,
                    paddingLeft: 30.86,
                    paddingRight: 19.56,
                    paddingTop: 9,
                    paddingBottom: 21,
                  })}
                >
                  <Heading
                    size="SUB_SECTION"
                    className={{
                      display: '-webkit-box',
                      overflow: 'hidden',
                      '-webkit-box-orient': 'vertical',
                      '-webkit-line-clamp': 2,
                      textOverflow: 'ellipsis',
                      flexShrink: 0,
                    }}
                  >
                    {title}
                  </Heading>

                  <Spacer height={2} />

                  <Tooltip className={{ pointerEvents: 'none' }} showOnOverflowOnly value={description}>
                    <p
                      className={css({
                        color: MAGNETIC_TOKENS.COLORS.INVERSE_TEXT_MEDIUM_DISABLED,
                        font: MAGNETIC_TOKENS.TYPOGRAPHY.P4_DEFAULT,
                        overflow: 'hidden',
                        height: 0,
                        marginBlock: 0,
                        flexGrow: 1,
                      })}
                    >
                      {description}
                    </p>
                  </Tooltip>

                  <Spacer height={11} />

                  <a
                    className={css({
                      flexShrink: 0,
                      textDecoration: 'none',
                      display: 'block',
                      width: 'fit-content',
                    })}
                    href={link}
                    target="_blank"
                  >
                    <Button
                      className={{
                        '> svg': { height: 18, width: 18, marginRight: 0, marginLeft: MAGNETIC_TOKENS.SPACING[1] },
                        height: 'fit-content',
                        paddingLeft: 2,
                        marginLeft: -2,
                      }}
                      iconRight="Navigation.ArrowRight"
                      type="TERTIARY"
                    >
                      Read full story
                    </Button>
                  </a>
                </div>
              </Card>
            ))}
        </div>

        <Spacer height={13} />

        <div className={css({ display: 'flex', gap: 4, marginInline: 'auto', width: 'fit-content' })}>
          {items.map((_, i) => (
            <Button
              key={i}
              onClick={() => {
                setIntervalBuster();
                setSelected(i);
              }}
              className={css(
                { all: 'initial' },
                {
                  cursor: 'pointer',
                  borderRadius: '50%',
                  height: 10.4,
                  aspectRatio: '1/1',
                  backgroundColor: i === selected ? '#3E84E5' : '#D9D9D9',
                },
              )}
            />
          ))}
        </div>
      </div>
    </>
  );
};

Carousel.CACHE = {
  KEY: 'paris2024.LiveNewsDrawer.Carousel',
  MS: 1 * 60 * 60 * 1000 /* 1 hours */,
  clear: () => localStorage.removeItem(Carousel.CACHE.KEY),
  get: () => localStorage.getItem(Carousel.CACHE.KEY),
  set: (value: string) => localStorage.setItem(Carousel.CACHE.KEY, value),
};

Carousel.SAMPLE_DATA = [
  {
    title: 'Giroud late winner sends France to finals of Paris’24',
    description:
      'Lorem ipsum dolor sit amet consectetur. Id nisi vulputate nibh aliquet feugiat ac. Quam sit enim ipsum montes sed nisi fusce. Turpis lacus neque cras neque mattis elit semper.',
    link: 'https://example.com',
    image: 'assets/paris2024/sample1.png',
  },
  {
    title: 'Neeraj Chopra adds a golden chapter to Indian sports history',
    description:
      'Lorem ipsum dolor sit amet consectetur. Id nisi vulputate nibh aliquet feugiat ac. Quam sit enim ipsum montes sed nisi fusce. Turpis lacus neque cras neque mattis elit semper.',
    link: 'https://example.com',
    image: 'assets/paris2024/sample2.png',
  },
  {
    title: "Kenya's Kipchoge eyes historic Olympic marathon hat-trick",
    description:
      'Lorem ipsum dolor sit amet consectetur. Id nisi vulputate nibh aliquet feugiat ac. Quam sit enim ipsum montes sed nisi fusce. Turpis lacus neque cras neque mattis elit semper.',
    link: 'https://example.com',
    image: 'assets/paris2024/sample3.png',
  },
];
